// extracted by mini-css-extract-plugin
export default {"cardProductItem":"CheckboxGroup_cardProductItem__FOTCW","error":"CheckboxGroup_error__yqAoR","cardProductLabel":"CheckboxGroup_cardProductLabel__mysUN"};